import './App.css';
import React from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/Home';
import About from './components/About';
import JobList from './components/JobList';
import DyningTable from './components/DyningTable';
import Table from './components/Table';
import FoodItems from './components/FoodItems';
import Items from './components/Items';
import Asidde from './components/Asidde';
import SidebarMenu from './components/SidebarMenu';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Pay from './components/Pay';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Logout from './components/Logout';
import ItemsUpdate from './components/ItemsUpdate';
import TestPay from './components/TestPay';
import TakeAway from './components/TakeAway';
import ProtectedRoute from './components/ProtectedRoute ';
import Bill from './components/Bill';
import JobDetails from './components/JobDetails';
//import "bootstrap/dist/css/bootstrap.min.css";
//import "bootstrap/dist/js/bootstrap.bundle.min.js";


function LayoutWithSidebar() {
  return (
    <>
      <Header />
      <SidebarMenu />
        <Asidde />
        <Routes>
          <Route path="/table" element={ <ProtectedRoute><Table /></ProtectedRoute>} />
          <Route path="/food-item" element={<ProtectedRoute><FoodItems /></ProtectedRoute>} />
          {/* <Route path="/item" element={<Items />} /> */}
            <Route
          path="/item"
          element={
            <ProtectedRoute>
              <Items />
            </ProtectedRoute>
          }
        />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/takeaway" element={<ProtectedRoute><TakeAway /></ProtectedRoute>} />
          <Route path="/payment/:order_id" element={<ProtectedRoute><Pay /></ProtectedRoute>} />
          <Route path="/test-payment/:order_id" element={<ProtectedRoute><TestPay /></ProtectedRoute>} />
          <Route path="/order-update/:order_id" element={<ProtectedRoute><ItemsUpdate /></ProtectedRoute>} />
       
          <Route path="/logout" element={<ProtectedRoute><Logout /></ProtectedRoute>} />
        </Routes>
      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        {/* Login page without header/sidebar/footer */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/login" element={<Login />} />
<Route path="/jobs" element={<JobList />} />
<Route path="/job/:id" element={<JobDetails />} />

<Route path="/bill/:order_id" element={<Bill />} />
        {/* All other pages with layout */}
        <Route path="/*" element={<LayoutWithSidebar />} />
      </Routes>
    </Router>
  );
}

export default App;
